import React from "react";
import imagePlaceHolder from '../placeholder.png';
import Utility from "../utilities/utility";
import '../productGallery.css'


class ProductGallery extends React.Component {
  constructor(props) {
    super(props);

    const initialImages = props.images || [];

    this.state = {
      images: initialImages,
      selectedImage:
        initialImages.length > 0 ? this.getImageUrl(initialImages[0]) : "",
      newImageUrl: "",
      selectedFile : ''
    };
  }

  getImageUrl = (image) => {
    return !Utility.isEmpty(image) ? image.fullUrl : '';
  };

  handleImageClick = (image) => {
    this.setState({ selectedImage: this.getImageUrl(image) });

    this.props.setImageAsMain(image.imageId);
  };

  // ✅ Add image via URL
  handleAddImage = () => {
    const { newImageUrl, images } = this.state;

    if (!newImageUrl.trim()) return;

    const updatedImages = [...images, newImageUrl];

    this.setState({
      images: updatedImages,
      selectedImage: this.getImageUrl(updatedImages[0]),
      newImageUrl: ""
    });
  };

  // ✅ Add image via file upload

  handleFileChange = async(event) => {
    const file = event.target.files[0];
    if (!file) return;

    this.setState({ selectedFile: file, message: "" });

    const resizedImage = await Utility.resizeImage(file, 400);
   
    this.props.addProductImage(this.state.selectedFile.name, resizedImage);

    /*const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result; // includes data:image/jpeg;base64,...

      this.props.addProductImage(this.state.selectedFile.name, resizedImage);
      this.setState({
        base64Image: base64String,
        preview: base64String
      });
    };

    reader.readAsDataURL(file);*/
  };



  handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const imageUrl = URL.createObjectURL(file);

    const updatedImages = [...this.state.images, imageUrl];

    this.setState({
      images: updatedImages,
      selectedImage: this.getImageUrl(updatedImages[0])
    });
  };

  // ❌ Remove image
  handleRemoveImage = (index, imageId) => {
    let updatedImages = [...this.state.images];
    updatedImages.splice(index, 1);

    this.setState({
      images: updatedImages,
      selectedImage:
        updatedImages.length > 0
          ? this.getImageUrl(updatedImages[0])
          : ""
    });

    this.props.removeImage(imageId)
  };

  render() {
    const { images, selectedImage, newImageUrl } = this.state;

    return (
      <div className="gallery">
        {/* Main Image */}
        <div className="main-image">
          <img
            src={
              selectedImage ||
              imagePlaceHolder
            }
            alt="Main"
          />
        </div>

        {/* Add Image Section */}
        <div className="add-image">
          <label htmlFor="files" className="btn btn-secondary">Ajoute une image</label>
          <input id="files" type="file" style={{display:'none'}} accept="image/*" onChange={this.handleFileChange} />
        </div>

        {/* Thumbnails */}
        <div className="thumbnails">
          {images.map((image, index) => {
            const imageUrl = this.getImageUrl(image);

            return (
              <div className="thumb-wrapper" key={index}>
                <img
                  src={imageUrl}
                  alt={`Thumbnail ${index + 1}`}
                  className={`thumb ${
                    selectedImage === imageUrl ? "active" : ""
                  }`}
                  onClick={() => this.handleImageClick(image)}
                />

                {/* Remove Button */}
                <button
                  className="remove-btn"
                  onClick={() => this.handleRemoveImage(index, image.imageId)}
                >
                  ×
                </button>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default ProductGallery;